import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarMonthViewDay, CalendarView } from 'angular-calendar';
import { endOfDay, isSameDay, isSameMonth, longFormatters, startOfDay } from 'date-fns';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { AttentionStates } from 'src/app/core/enums/attentionsStates'
import { Attention } from 'src/app/shared/models/attention';
import { GeneralService } from 'src/app/core/services/general.service';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { CasesFacade } from 'src/app/abstraction/cases.facade';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { ATTENTIONS_BACKGROUND_COLORS, ATTENTIONS_COLORS, AttentionsFacade } from '../../../../abstraction/attentions.facade';
import { EvolutionsFacade } from '../../../../abstraction/evolutions.facade';
import { CaseDateFilters } from '../../../../abstraction/cases.facade';
import { ButtonsNewDateScheduleNavigator } from '../../../../core/services/general.service';
import { DateService } from 'src/app/core/services/date.service';
import { OPTIONS } from '../provision-scheme/provision-scheme.component';
import { SelectionModel } from '@angular/cdk/collections';
import * as momentRange from 'moment-range';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { CalendarCaseService } from 'src/app/core/services/calendar-case.service';
import { Logger } from 'sass';
import { AttentionType } from 'src/app/core/enums/attentionType';
import { isSelfCareAttention } from 'src/app/core/utils/practice-restriction.utils';
import { MODULE_CALENDAR_COLORS } from 'src/app/core/theme/theme.calendar.defaults';
import { Case } from 'src/app/shared/models/case';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';

@Component({
    selector: 'app-calendar-case',
    templateUrl: './calendar-case.component.html',
    styleUrls: ['./calendar-case.component.scss']
})
export class CalendarCaseComponent implements OnInit {

    @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
    @ViewChildren('targetElement', { read: ElementRef }) targetElements!: QueryList<ElementRef>;

    @Input() events: CalendarEvent[];
    @Input() loading: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() attentions: Attention[];
    @Input() optionSelected;
    @Input() colorsForAgreements: Map<number, { primary: string, secondary: string }>;
    @Input() fromProviderSchedule:boolean = false;
    @Input() case: Case;

    @Output() onDayClicked = new EventEmitter<Date>();
    @Output() onEventClicked = new EventEmitter<{ calendarEvent: CalendarEvent, editMode?: string }>();
    @Output() onEventDelete = new EventEmitter<CalendarEvent>();
    @Output() onChangeMonth = new EventEmitter<Date>();
    @Output() option = new EventEmitter<string>();
    @Output() onClickCreateAttention = new EventEmitter<any>(); // Emitter to create attention
    @Output() viewSelected = new EventEmitter<CalendarView>(); // Emitter to create attention

    @ViewChild("extraAttentionsTemplate") extraAttentionsTemplate: TemplateRef<any>

    _dialogRef;
    _monthEvents: CalendarEvent[];
    attentionStates = AttentionStates;
    ATTENTIONS_COLORS = ATTENTIONS_COLORS;
    ATTENTIONS_BACKGROUND_COLORS = ATTENTIONS_BACKGROUND_COLORS;
    colorReferences;
    // Month - Week - Day
    view: CalendarView = CalendarView.Month;
    CalendarView = CalendarView;
    // Día actual seleccionado
    viewDate: Date = new Date();
    viewDateX: Date = new Date();
    lastEvent: CalendarEvent;
    previousViewDate = this.viewDate;
    modalData: {
        action: string;
        event: CalendarEvent;
    };

    public readonly TEXT_DATE_FROM = this.experienceI18n.translate('modules.cases.calendar-case.mostrar-fecha-realizada', undefined, 'Mostrar fecha Realizada');
    public readonly TEXT_DATE_SCHEDULED = this.experienceI18n.translate('modules.cases.calendar-case.mostrar-fecha-agendada', undefined, 'Mostrar fecha Agendada');

    isChangedDate: boolean = false;
    eventStart: Date;
    dateToShow: string = this.TEXT_DATE_SCHEDULED;
    // viewSelected: string = "mes";
    OPTIONS = OPTIONS
    totalsByAttentionsState = new Array(Object.values(AttentionStates).length / 2).fill(0); // Create array with state totals with zero
    totalPricesByAttentionsState = new Array(Object.values(AttentionStates).length / 2).fill(0); // Create array with state totals with zero
    statesSelected = new SelectionModel<number>(true, []);
    filteredAttentions: Attention[];

    actions: CalendarEventAction[] = [
        {
            label: `<span class="pxs-2 text-primary-darker">
                  ${this.experienceI18n.translate('modules.cases.calendar-case.ver', undefined, 'Ver')}
              </span>`,
            a11yLabel: 'Edit',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Edit', event);
            },
        },
        {
            label: `<span class="pxs-2 text-warn">
                  ${this.experienceI18n.translate('common.delete-variant', undefined, 'Eliminar')}
              </span>`,
            a11yLabel: 'Delete',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Deleted', event);
            },
        },
    ];

    refresh: Subject<any> = new Subject();
    activeDayIsOpen: boolean = false;

    // HISTORY MODE
    historyModeActivated: boolean;
    _historyModeActivated: Subscription;
    _historyModeDate: Subscription;
    historyModeDate: Date;
    _isLoadingGetAttentions: any;
    _isLoadingGettingEvolutions: any;
    isLoadingGetAttentions: any;
    isLoadingGettingEvolutions: any;

    rangeDate: CaseDateFilters;
    disabledButtonPrevious: boolean;
    disabledButtonNext: boolean;

    buttonsNewDateScheduleNavigator: ButtonsNewDateScheduleNavigator;
    totalHours: any;
    totalCost: any;
    totalAttentions: any;
    viewType: string = 'units';
    extraDayAttentions: CalendarEvent[];
    dayOpened: moment.Moment;

    private readonly MODULE_COLORS: { primary: string; secondary: string }[] = MODULE_CALENDAR_COLORS;


    constructor(private cd: ChangeDetectorRef,
        private generalService: GeneralService,
        public entitiesFacade: EntitiesFacade,
        public dialog: MatDialog,
        private casesFacade: CasesFacade,
        private attentionsFacade: AttentionsFacade,
        private evolutionsFacade: EvolutionsFacade,
        private dateService: DateService,
        public calendarCaseService: CalendarCaseService,
        private experienceI18n: ExperienceI18nService
    ) { }

    ngOnInit() {

        if (this.events) {
            const referencesByAgreement = new Map<string | null, CalendarEvent>();
            for (const event of this.events) {
                const agreementId = event.meta.attention.agreementId;
                const key = agreementId == null ? null : String(agreementId);
                if (!referencesByAgreement.has(key)) {
                    referencesByAgreement.set(key, event);
                }
            }
            this.colorReferences = Array.from(referencesByAgreement.values()).map(event => ({
                title: event.meta.referenceText,
                color: event.color
            }));
        }

        // Spinner control
        this._isLoadingGetAttentions = this.attentionsFacade.isLoadingGetAttentions$().subscribe(loadingAttentions => this.isLoadingGetAttentions = loadingAttentions);
        this._isLoadingGettingEvolutions = this.evolutionsFacade.isLoadingGetEvolutions$().subscribe(loadingEvolutions => this.isLoadingGettingEvolutions = loadingEvolutions);

        this._historyModeDate = this.casesFacade.getCaseDateFilters$().subscribe(rangeDate => {
            if (!!rangeDate) {
                this.rangeDate = { ...rangeDate, historyToDate: moment(moment(rangeDate.historyToDate).format('YYYY-MM-DD')).toDate() };
                this.buttonsNewDateScheduleNavigator = this.generalService.controlCalendarView(this.rangeDate.historyFromDate, this.rangeDate.historyToDate, this.view);
                this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar;
                this.updateScheduleView();
            }
        })
    }

    get monthEvents() {return this._monthEvents}
    set monthEvents(value) { this._monthEvents = value
    }

    getEventTitle(attention: Attention): string {
    if (isSelfCareAttention(attention)) {
      const practiceName = attention?.practice?.name?.trim();
      if (practiceName) {
        return practiceName;
      }
      const patientLabel = this.entitiesFacade.getProvidersFullName(attention?.patient);
      return patientLabel !== this.experienceI18n.translate('modules.cases.calendar-case.sin-datos', undefined, 'Sin datos') ? patientLabel : this.experienceI18n.translate('modules.cases.calendar-case.autocuidado', undefined, 'Autocuidado');
    }

    // Módulos: usar nombre del módulo (inyectado por el padre)
    if (attention.type === AttentionType.MODULE) {
      const cmName = (attention as any)?.caseModuleName;
      if (typeof cmName === 'string' && cmName.trim().length) return cmName.trim();
      return attention?.practice?.name ?? this.experienceI18n.translate('modules.cases.calendar-case.modulo', undefined, 'Módulo');
    }

    // Flujo normal
    const providerName = this.entitiesFacade.getProvidersFullName(attention?.provider);
    const fee = attention?.providerFee;
    return fee != null ? `${providerName} - $${fee}` : providerName;
  }

    private getEventColor(attention: Attention): { primary: string; secondary: string } {
    const agreementId = (attention as any)?.agreementId;

    if (isSelfCareAttention(attention)) {
      return { primary: 'var(--status-scheduled)', secondary: 'var(--status-scheduled)' };
    }

    // 1) Si tiene acuerdo y existe en el map => ese color
    const byAgreement = agreementId != null ? this.colorsForAgreements?.get(agreementId) : undefined;
    if (byAgreement) return byAgreement;

    // 2) Si es módulo => color determinístico por caseModuleId
    const caseModuleId = (attention as any)?.caseModuleId;
    if (caseModuleId != null) {
      const idx = Math.abs(Number(caseModuleId)) % this.MODULE_COLORS.length;
      return this.MODULE_COLORS[idx];
    }

    // 3) Fallback general (gris)
    return { primary: 'var(--color-grey-light)', secondary: 'var(--color-grey-light)' };
  }

    clickonCalendarPreviousNextView() {
        if(!this.fromProviderSchedule){
        this.buttonsNewDateScheduleNavigator = this.generalService.controlCalendarView(this.rangeDate.historyFromDate, this.rangeDate.historyToDate, this.view, this.viewDate)
        this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar
        this.updateScheduleView();
        }
    }

    // En el flujo de agenda del prestador la navegación no está acotada por el rango del caso,
    // por lo que se avisa al padre para que recargue la ventana de atenciones al cambiar de mes.
    onViewDateChange(date: Date) {
        this.closeOpenMonthViewDay();
        if (this.fromProviderSchedule) {
            this.viewDate = date;
            this.updateScheduleView();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes['attentions'] && changes['attentions'].currentValue) {
            this.filterAttentionsByState()
            this.events = this.attentionsToEvents(this.attentions);
        }

        if (changes['events'] && changes['events'].currentValue) {
            this.events = this.addActionsEvents(this.events);
        }

        if (this.events) {
            const colorsByReference = new Map<string, CalendarEvent['color']>();
            for (const event of this.events) {
                if (!colorsByReference.has(event.meta.referenceText)) {
                    colorsByReference.set(event.meta.referenceText, event.color);
                }
            }
            this.colorReferences = Array.from(colorsByReference, ([title, color]) => ({ title, color }));
            this.setViewDateWithLastEventDate();
            this.mapMonthEvents();
        }
        this.cd.detectChanges();
    }

    mapMonthEvents() {
        this.monthEvents = this.events.map((ev) => {
            if(!!ev.meta.attention.toDateAdjusted) {
                ev.meta.isNotOneDayEvent = moment(ev.meta.attention.toDateAdjusted).isAfter(ev.start, 'day');
            }else{
                ev.meta.isNotOneDayEvent = moment(ev.meta.attention.toDate).isAfter(ev.start, 'day');
            }
            return ev
        })
        this.attentionsFacade.setIsLoadingAttentionsProcess(false)
    }

    private addActionsEvents(events: CalendarEvent[]): CalendarEvent[] {
        const eventsComposed: CalendarEvent[] = events.map(eventUncomposed => {
            const event: CalendarEvent = {
                ...eventUncomposed,
                actions: this.actions,
            };
            return event;
        });
        return eventsComposed;
    }

    setViewDateWithLastEventDate() {
        if (this.events != null && this.events != undefined && this.events.length > 0) {

            if (this.viewDate === undefined) {
                let auxDate = this.events[0].start;
                this.events.forEach((ev) => {
                    if (ev.start > auxDate) {
                        auxDate = ev.start;
                    }
                })
                this.viewDate = auxDate;
            }
        }
    }

    badgeClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        event.preventDefault();
        event.stopPropagation()
        if (isSameMonth(date, this.viewDate)) {
            if (
                (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
                events.length === 0
            ) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }

    dayClicked(_event) {
        if (this.readOnly) return;
        console.log('Day clicked');
        this.onDayClicked.emit(_event.date);
    }

    eventClicked(_event, event?: CalendarEvent) {
        _event.stopPropagation();
        if (this.readOnly) return;
        console.log('Event clicked', event, _event);
        if (event != null) {
            this.onEventClicked.emit({ calendarEvent: event.meta.attention, editMode: 'DSP' });
        } else {
            this.onEventClicked.emit({ calendarEvent: _event.meta.attention, editMode: 'DSP' });
        }
    }

    hourSegmentClicked(_event) {
        if (this.readOnly) return;
        console.log('Hour segment clicked');
        this.onDayClicked.emit(_event);
    }

    eventTimesChanged({
        event,
        newStart,
        newEnd,
    }: CalendarEventTimesChangedEvent): void {
        if (this.readOnly) return;
        this.events = this.events.map((iEvent) => {
            if (iEvent === event) {
                return {
                    ...event,
                    start: newStart,
                    end: newEnd,
                };
            }
            return iEvent;
        });
        this.handleEvent('Dropped or resized', event);
    }

    handleEvent(action: string, event: CalendarEvent): void {
        if (this.readOnly) return;
        console.log('HandleEvent clicked');
        if (action === 'Edit') {
            this.onEventClicked.emit(event.meta.attention);
        } else if (action === 'Deleted') {
            this.onEventDelete.emit(event.meta.attention);
        }
    }

    // TODO pasar al padre
    addEvent(): void {
        if (this.readOnly) return;
        console.log('NewEvent clicked');
        this.events = [
            ...this.events,
            {
                title: 'New event',
                start: startOfDay(new Date()),
                end: endOfDay(new Date()),
                draggable: false,
                resizable: {
                    beforeStart: false,
                    afterEnd: false,
                },
            },
        ];
    }

    deleteEvent(eventToDelete: CalendarEvent) {
        if (this.readOnly) return;
        console.log('DeleteEvent clicked');
        this.events = this.events.filter((event) => event !== eventToDelete);
    }

    setView(view: CalendarView) {
        this.view = view;
        this.viewSelected.emit(this.view);
    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }

    updateScheduleView() {
        this.viewDateX = this.viewDate;

        const actualMonth = moment(this.viewDate).month() + 1;
        const previousMonth = moment(this.previousViewDate).month() + 1;

        if (actualMonth != previousMonth) {
            this.previousViewDate = this.viewDate;
            this.onChangeMonth.emit(this.viewDate)
        }
        this.calculateTotalsByAttentionState();
    }

    attentionsToEvents(attentions: Attention[]): CalendarEvent[] {
    const events: CalendarEvent[] = attentions.map(attention => {
      this.eventStart = this.isChangedDate ? new Date(attention.fromScheduled) : new Date(attention.fromDate);

      const event: CalendarEvent = {
        id: attention.id,
        color: this.getEventColor(attention),
        title: this.getEventTitle(attention),
        start: this.eventStart,
        end: !!attention.toDateAdjusted ? new Date(attention.toDateAdjusted) : new Date(attention.toDate),
        draggable: false,
        allDay: false,
        resizable: { beforeStart: false, afterEnd: false },
        meta: {
          attention,
          referenceText: isSelfCareAttention(attention)
            ? `${attention.practice?.name ?? this.experienceI18n.translate('modules.cases.calendar-case.autocuidado', undefined, 'Autocuidado')} • ${attention.patient?.surname ?? ''}`
            : `${attention.practice?.name} • ${attention.patient?.surname} | ${this.entitiesFacade.getProvidersFullName(attention?.provider)}`,
        }
      };
      return event;
    });

    return events;
  }

    onToggleChange($event: MatSlideToggleChange) {
        this.isChangedDate = $event.checked;
        this.dateToShow = this.isChangedDate ? this.TEXT_DATE_FROM : this.TEXT_DATE_SCHEDULED;

        if (this.attentions) {
            this.events = this.attentionsToEvents(this.attentions);
            this.mapMonthEvents();
        }
    }

    selectOption(option) {
        this.option.emit(option);
    }

    selectView(option) {
        this.setView(option.value);
        this.buttonsNewDateScheduleNavigator = this.generalService.controlCalendarView(this.rangeDate.historyFromDate, this.rangeDate.historyToDate, this.view);
        this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar
        this.updateScheduleView();
    }

    createAttention() {
        if (this.readOnly) return;
        const configCreateAttention = {
            view: this.view,
            date: this.viewDate
        }

        this.onClickCreateAttention.emit(configCreateAttention);
    }

    ngOnDestroy(): void {
        this._historyModeDate.unsubscribe();
         this.buttonsNewDateScheduleNavigator = null;
    }

    mustShowSpinner() {
        if (this.isLoadingGetAttentions || this.isLoadingGettingEvolutions) {
            return true;
        }
        return false;
    }

    // Color disabled if day is out of date range
    applyDateSelectionPolicy(body: { date: Date; inMonth?: boolean }[]) {
        body?.forEach(day => {
            if (!!this.rangeDate) {
                if (moment(day.date).isValid() && !(moment(day.date).isBetween(this.rangeDate.historyFromDate, this.rangeDate.historyToDate, undefined, '[]'))) {
                    day.inMonth = false; // Day disabled if out of range
                }
            }
        });
    }

    onChangeToggle(event) {
        if (!event.checked) {
            this.viewType = "units";
        } else {
            this.viewType = "price";
        }
    }

    getBackgroundColor(element) {
        if (!this.statesSelected.selected.includes(element)) {
            return this.ATTENTIONS_BACKGROUND_COLORS[element];
        } else {
            return "white";
        }
    }

    getBorderStyle(element) {
        if (!this.statesSelected.selected.includes(element)) {
            return "none";
        } else {
            return "1px solid " + this.ATTENTIONS_BACKGROUND_COLORS[element];
        }
    }
    removeFilters() {
        this.statesSelected.clear();
        this.filterAttentionsByState();
    }

    selectState(id: number) {
        this.statesSelected.toggle(id);
        this.filterAttentionsByState();
    }

    showImport(totalByState: number, stateId: number) {
        let show: boolean = false;
        if (totalByState != 0 || this.totalsByAttentionsState[stateId] != 0) {
            show = true;
        }
        return show;
    }

    filterAttentionsByState() {
        if (!!this.statesSelected.selected) {
            this.filteredAttentions = this.attentions.filter(att => !this.statesSelected.selected.includes(att.state.id));
            this.events = this.attentionsToEvents(this.filteredAttentions);
            this.mapMonthEvents();
        }
        this.calculateTotalsByAttentionState();
    }

    calculateTotalsByAttentionState() {
        // Always get totals
        this.totalsByAttentionsState.fill(0);
        this.totalPricesByAttentionsState.fill(0);
        this.totalAttentions = 0;
        this.totalHours = 0;
        let rangeStart = NaN;
        let rangeEnd = NaN;
        switch (this.view) {
            case (CalendarView.Month):
                rangeStart = this.dayStartTs(this.rangeDate?.historyFromDate);
                rangeEnd = this.dayStartTs(this.rangeDate?.historyToDate);
                break;
            case (CalendarView.Week):
                rangeStart = this.dayStartTs(this.viewDateX);
                rangeStart = this.addCalendarDays(rangeStart, -((new Date(rangeStart).getDay() + 6) % 7));
                rangeEnd = this.addCalendarDays(rangeStart, 6);
                break
            case (CalendarView.Day): {
                rangeStart = this.dayStartTs(this.viewDateX);
                rangeEnd = rangeStart;
                break;
            }
        }
        const hasValidRange = Number.isFinite(rangeStart)
            && Number.isFinite(rangeEnd)
            && rangeStart <= rangeEnd;
        const attentionsFilteredByDate = (this.attentions ?? []).filter(att => {
            if (!hasValidRange) return true;
            const attentionDay = this.dayStartTs(att.fromDate);
            return Number.isFinite(attentionDay) && attentionDay >= rangeStart && attentionDay <= rangeEnd;
        });
        attentionsFilteredByDate.forEach(att => {
            this.totalsByAttentionsState[att.state.id] += 1;
            if (att.state.id == this.attentionStates.AGENDADA && this.calendarCaseService.practiceCountedByHours(att.practice)) {
                this.totalPricesByAttentionsState[att.state.id] += (att.toScheduled && att.fromScheduled) ? moment.duration(moment(att.toScheduled).diff(att.fromScheduled)).hours() * att.provisionFee : att.provisionFee // Attention by hours
            } else {
                this.totalPricesByAttentionsState[att.state.id] = this.calendarCaseService.practiceCountedByHours(att.practice) || (att.isSupply && att.practice?.name != "Entrega insumos") ?
                    this.totalPricesByAttentionsState[att.state.id] += (att.provisionFee * (att.quantity != null ? att.quantity : 1))
                    :
                    this.totalPricesByAttentionsState[att.state.id] += att.provisionFee;
                this.totalHours += !!att.quantity && !this.statesSelected?.selected?.includes(att?.state?.id) ? att?.quantity : 0;
            }

            if (!this.statesSelected.selected.includes(att.state.id)) {
                this.totalAttentions += 1;
            }

        });
    }

    private dayStartTs(value: Date | string | number | null | undefined): number {
        if (value == null) return NaN;

        let date: Date;
        if (value instanceof Date) {
            date = new Date(value.getTime());
        } else if (typeof value === 'string') {
            const dateOnly = /^(\d{4})-?(\d{2})-?(\d{2})$/.exec(value);
            date = dateOnly
                ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
                : new Date(value);
        } else {
            date = new Date(value);
        }
        if (Number.isNaN(date.getTime())) return NaN;
        date.setHours(0, 0, 0, 0);
        return date.getTime();
    }

    private addCalendarDays(timestamp: number, days: number): number {
        const date = new Date(timestamp);
        date.setDate(date.getDate() + days);
        return date.getTime();
    }

    onClickSeeMoreAttentions(_event: any, day: CalendarMonthViewDay) {
        _event.preventDefault();
        _event.stopPropagation();
        this.extraDayAttentions = day.events;
        let template = this.extraAttentionsTemplate;
        this.dayOpened = moment(day.date);

        const dialogWidth = 300;  // Ancho del diálogo
        const dialogHeight = 400; // Altura del diálogo

        // Calcula las posiciones deseadas basadas en el evento de clic
        let left = _event.clientX - dialogWidth / 2;
        let top = _event.clientY - dialogHeight;

        // Obtén los límites de la ventana del navegador
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Ajusta la posición si el diálogo se sale del lado izquierdo o derecho de la pantalla
        if (left < 0) {
            left = 0;
        } else if (left + dialogWidth > viewportWidth) {
            left = viewportWidth - dialogWidth;
        }

        // Ajusta la posición si el diálogo se sale de la parte superior o inferior de la pantalla
        if (top < 0) {
            top = 0;
        } else if (top + dialogHeight > viewportHeight) {
            top = viewportHeight - dialogHeight;
        }

        // Abre el diálogo con la posición ajustada
        this._dialogRef = this.dialog.open(DialogComponent, {
            disableClose: false,
            minWidth: `${dialogWidth}px`,
            maxHeight: `${dialogHeight}px`,
            data: { template },
            position: { left: `${left}px`, top: `${top}px` }
        });
    }

    applyMaxWidth() {
        const sourceElement = document.querySelector('mwl-calendar-month-cell');
        const sourceWidth = sourceElement?.clientWidth - 10;
        this.targetElements.forEach(targetElement => {
            targetElement.nativeElement.style.width = `${sourceWidth}px`;
            targetElement.nativeElement.style.maxWidth = `${sourceWidth}px`;
        });
    }

    ngAfterViewInit() {
        this.applyMaxWidth();
    }


    ngAfterViewChecked() {
        this.applyMaxWidth();
    }
}
